<template>
  <SkeletonItem
    v-for="item in LOADERS"
    :key="item.id"
    :color="item.color"
    :style="item.style"
    :width="item.width"
  />
</template>

<script setup>
import SkeletonItem from '@/components/ui/SkeletonLoaders/SkeletonItem'

defineOptions({
  name: 'ToolbarFiltersLoader'
})

const props = defineProps({
  splitFirstFilter: {
    type: Boolean
  }
})

const LOADERS = [
  {
    id: 0,
    width: '96px',
    color: 'var(--dark-2)',
    style: props.splitFirstFilter ? { marginRight: '12px' } : {}
  },
  {
    id: 1,
    width: '110px'
  },
  {
    id: 2,
    width: '110px'
  },
  {
    id: 3,
    width: '78px'
  }
]
</script>

<style lang="scss" scoped></style>
